/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { WhatsAppConversationIndexResponse } from '../types/WhatsAppConversationIndex'

/**
 * GET /whatsapp/conversations
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppConversationController.php WhatsAppConversationController::index
 */
export async function whatsAppConversationIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppConversationIndexResponse>> {
	return axiosInstance.get('/whatsapp/conversations', config)
}
